import React from "react";
import "./Success.css";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
const Success = () => {
  const { t } = useTranslation();
  const { order } = JSON.parse(localStorage.getItem("order"));
  console.log('order: ', order);
  console.log("jkdajk", JSON.parse(localStorage.getItem("order")))
  return (
    <div>
      <div className="firework"></div>
      <div className="firework"></div>
      <div className="firework"></div>
      <section className="banner-ImeiBlacklist py-md-5 position-relative">
        <div className="container py-md-5">
          <div className="row justify-content-center p-3 success-section">
            <div className="col-md-12 text-center p-0">
              <img className="img-fluid success-img" src="/images/cele.png" alt="" />
              <h2 className="fw-semibold display-4 text-center mt-md-3">
                {t('SucH1')}
              </h2>
              <p className="text-center order-detail-text fs-5">{t('SucH2')}</p>
            </div>

            <div className="row justify-content-center pt-3 px-0">
              <div className="col-12 col-md-9 d-md-flex justify-content-between success-bg p-md-4 p-3 mt-3 rounded-4">
                <h5 className="mb-md-0 mb-3 order-detail-left">{t('SucH3')}</h5>
                <h5 className="mb-0 order-detail-right">{order?.customerEmail}</h5>
              </div>
              <div className="col-12 col-md-9 d-md-flex justify-content-between success-bg  p-md-4 p-3 mt-3 rounded-4">
                <h5 className="mb-md-0 mb-3 order-detail-left">{t('SucH4')}</h5>
                <h5 className="mb-0 order-detail-right">{order?.invoice}</h5>
              </div>
              <div className="col-12 col-md-9 d-md-flex justify-content-between success-bg  p-md-4 p-3 mt-3 rounded-4">
                <h5 className="mb-md-0 mb-3 order-detail-left">{t('SucH6')}</h5>
                <h5 className="mb-0 order-detail-right">{order?.product?.delivery_time}</h5>
              </div>
              <div className="col-12 col-md-9 d-md-flex justify-content-center my-5 px-0">
                <Link  className=" rounded-4  py-3 px-4 me-2 need-support1" to={'/contact-us'} style={{ 'color': '#fff', 'text-decoration': 'none' }}> {t('SucB1')} </Link>
                {order?.customerImei &&
                  <Link className=" rounded-4 py-3 px-4 ms-2 need-supports" to={'/track-order'} style={{ 'color': '#fff', 'text-decoration': 'none' }}>{t('SucB2')} </Link>
                }
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}; 
export default Success;
